import styled from 'styled-components';

import { LinkCSS } from './SharedLink';

import type { LinkButtonProps } from './SharedLink';

const SLinkButton = styled.button<LinkButtonProps>`
  ${LinkCSS}

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

/**
 * These are buttons that look like normal links but have the functionality of buttons.
 * SECONDARY looks like an inline link
 */
function LinkButton({
  type = 'button',
  ofType = 'PRIMARY',
  colorVariant,
  underline,
  disabled,
  children,
  ...rest
}: LinkButtonProps) {
  return (
    <SLinkButton
      ofType={ofType}
      type={type}
      colorVariant={colorVariant}
      underline={underline}
      disabled={disabled}
      aria-disabled={disabled}
      {...rest}
    >
      {children}
    </SLinkButton>
  );
}

export { LinkButton };
